import { useAxleList } from '@src/axles/hooks/useAxleList';
import type { CollapseListener } from '@src/orders/CollapseListener';
import { AxleSummary } from '@src/orders/domain/AxleSummary';
import type { Order } from '@src/orders/domain/Order';
import { editOrderAxleConfigurationEvents } from '@src/orders/EditOrderEvents';
import { AxleInformationSectionContent } from '@src/orders/PermitFormSections/axlesConfiguration/AxleInformationSectionContent';
import type { AllAxlesInformation } from '@src/orders/PermitFormSections/axlesConfiguration/AxleInformationTypes';
import { TractorAxlesFormUtils } from '@src/permitField/TractorAxlesFormUtils';
import { TractorIdField } from '@src/permitField/TractorInformationFields';
import { TrailersFormName } from '@src/permitField/TrailerInformationFields';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = {
  clientId: string;
  fields: string[];
  order: Order;
} & CollapseListener;

export const AxleInformationSection = (props: Props) => {
  const { axles: persistedAxles, isLoading: isLoadingAxles } = useAxleList(
    props.clientId,
  );
  const { control } = useFormContext<AllAxlesInformation>();

  const [trailerFormValues, tractorAxles, tractorId] = useWatch({
    control,
    name: [
      TrailersFormName,
      TractorAxlesFormUtils.pathToAxles,
      TractorIdField.fieldName,
    ],
  });

  const newAxleSummary = AxleSummary.fromFormAndPersistedValues(
    trailerFormValues,
    {
      id: tractorId ?? 'new',
      axles: tractorAxles,
    },
    persistedAxles,
  );

  if (props.fields.length === 0) {
    return null;
  }

  return (
    <AxleInformationSectionContent
      fields={props.fields}
      axleSummary={newAxleSummary}
      isLoading={isLoadingAxles}
      order={props.order}
      {...editOrderAxleConfigurationEvents}
    />
  );
};
